import * as Yup from "yup";

export const messageValidte = Yup.object().shape({
  message: Yup.string().required("وارد کردن پیام الزامی است"),
});
